import { render, staticRenderFns } from "./cadastro-simples-list.vue?vue&type=template&id=214e6c5e"
import script from "./cadastro-simples-list.vue?vue&type=script&lang=js"
export * from "./cadastro-simples-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports